import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { RootState } from '@/store'

export default Vue.extend<any, any, any, any>({
  computed: {
    ...mapState<RootState>({
      predefinedSkills: (state: RootState) => state.skills.skills.value,
      deprecatedSkills: (state: RootState) => state.skills.deprecatedSkills,
      skill: (state: RootState) => state.browseGigs.skill,
    }),
    ...mapGetters({
      categories: 'skills/getCategories',
    }),
    skillsLoading() {
      return this.predefinedSkills.length === 0
    },
    skillDetails() {
      const skill = this.$route.params?.skill
      if (skill) {
        return [...this.predefinedSkills, ...this.deprecatedSkills].find((s: any) => s.url === skill) || {}
      }
      return {}
    },
  },
})
